// import { useQuery } from '@apollo/client';
import styled from "@emotion/styled";
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { i18n, mq, setCustomer, setFlowType, setProgressBarPercentage, useAppDispatch } from 'src/common';
import { Card, CustomerForm, Flex, HtmlText, HtmlTextLink, Text } from 'src/components';

// dayjs.extend(customParseFormat);

// const MAX_AGE = 120;

// const isValidBirthDate = (value: string): boolean => {
//   const parsed = dayjs(value, DateFormat, true);
//   if (!parsed.isValid()) return false;
//   const now = dayjs();
//   if (parsed.isAfter(now)) return false;
//   if (parsed.isBefore(now.subtract(MAX_AGE, 'year'))) return false;
//   return true;
// };

const TitleStyle = styled(Text)({
  marginBottom: 16
})

// const BestPriceCardStyle = styled(BestPriceCard)({
//   marginBottom: 8,
// })

const CardStyle = styled(Card)(
  mq({
    padding: ['16px', '16px', "24px", "24px", "40px"],
    marginBottom: 16
  })
)

const htmlTextLinks: Array<HtmlTextLink> = [
  { value: 'form', link: 'https://kompare.hr/obrazac-za-prituzbe/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.form') },
  { value: 'mail', link: 'mailto:szop@kompare.hr', translation: 'szop@kompare.hr' },
  { value: 'here', link: 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.here') },
  { value: 'privacyPolicy', link: 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.privacyPolicy') },
  { value: 'terms', link: 'https://kompare.hr/uvjeti-koristenja/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.terms') },
];

const CustomerWithDatePage = () => {
  // DEV-4191: BestPriceCard hidden — birthDate no longer editable, taken directly from URL params
  const { birthDate } = useParams();
  // const [birthDate, setBirthDate] = useState<string | undefined>(initialBirthDate);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  // const soId = useAppSelector((store: RootState) => store.model.offer.soId);

  useEffect(() => {
    dispatch(setProgressBarPercentage(20));
    dispatch(setFlowType('web'));
  }, []);

  useEffect(() => {
    dispatch(setCustomer({ birthDate, age: dayjs().diff(dayjs(birthDate), 'year') }));
  }, [birthDate]);

  /* const { data, loading } = useQuery(getWebCalculationsSupplementary, {
    variables: {
      input: {
        birthDate,
        coverages: [],
        type: ProductTypeCodeEnum.DOPUNSKO
      },
      soId: soId || ''
    },
    skip: !birthDate
  }); */

  // Destrukturiranje podataka
  // const { getCalculations } = data || {};


  // Pronalaženje proizvoda s najmanjom cijenom na rate
  /* const offerWithLowestInstallmentPrice = getCalculations?.length > 0 ? getCalculations?.reduce((prevOffer: any, currentOffer: any) => {
    if (!prevOffer) {
      return currentOffer;
    }

    if (prevOffer.prices.generalTransferWithInstallments === 0
      || currentOffer.prices.generalTransferWithInstallments < prevOffer.prices.generalTransferWithInstallments) {
      return currentOffer;
    }
    return prevOffer;
  }, null) : undefined;

  // const onContractNow = () => {
  //   if (!birthDate || !isValidBirthDate(birthDate)) return;
  //   navigate(`${AppRoutes.CUSTOMER_CONTRACT_NOW.fullPath}/${birthDate}`);
  // } */

  return (
    <Flex vertical gap={24}>
      {/* loading ? <Loader /> : (<BestPriceCardStyle
        birthDate={birthDate}
        price={offerWithLowestInstallmentPrice ? (offerWithLowestInstallmentPrice.prices.generalTransferWithInstallments / 12) : undefined}
        onBirthDateChange={onBirthDateChange}
        onContractNow={onContractNow}
      />
      ) */}
      <CardStyle title={<TitleStyle type="large" bold>{i18n.t('pages.customerPage.titleWithDateOfBirth')}</TitleStyle>}>
        <CustomerForm customer={{ birthDate }} formItems={['email', 'phoneNumber', 'hasPolicy']} />
      </CardStyle>
      <HtmlText i18nKey="pages.customerPage.gdprConsentWithParams" links={htmlTextLinks} />
    </Flex>
  );
}

export default CustomerWithDatePage;
